<div class="angular-editor-toolbar-set">
  <ng-content></ng-content>
</div>
